import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="relative pt-20 pb-32 px-4 overflow-hidden bg-gradient-to-b from-pastel-purple/30 to-pastel-mint/20" data-id="element-55">
      {/* Decorative elements */}
      <div className="absolute top-10 left-10 text-4xl animate-float opacity-50" data-id="element-56">
        ✨
      </div>
      <div className="absolute top-20 right-20 text-5xl animate-float-delayed opacity-50" data-id="element-57">
        ☁️
      </div>
      <div className="absolute bottom-20 left-1/4 text-3xl animate-float opacity-50" data-id="element-58">
        ⭐
      </div>

      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center relative z-10" data-id="element-59">
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} className="text-center md:text-left" data-id="element-60">
          <div className="inline-block bg-brand-purple text-white font-bold px-4 py-1 rounded-full mb-6 text-sm uppercase tracking-wider transform -rotate-2" data-id="element-61">
            ¡Oferta Especial Hoy! 🎁
          </div>
          <h1 className="text-5xl md:text-6xl font-bold text-brand-dark mb-6 leading-tight" data-id="element-62">
            Estimulación Temprana{' '}
            <span className="text-brand-purple" data-id="element-63">en Casa</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-700 mb-8 font-medium" data-id="element-64">
            La guía definitiva para padres de niños de 2 a 7 años. Descubre cómo
            potenciar el desarrollo de tu hijo de forma divertida y sencilla.
          </p>

          <div className="flex flex-col items-center md:items-start gap-4 mb-8" data-id="element-65">
            <div className="flex items-center gap-4 text-3xl font-display" data-id="element-66">
              <span className="text-gray-400 line-through decoration-red-500 decoration-4" data-id="element-67">
                $47
              </span>
              <span className="text-5xl font-bold text-brand-pink" data-id="element-68">$17</span>
            </div>
            <p className="text-sm text-gray-500 font-medium" data-id="element-69">
              Pago único • Acceso de por vida
            </p>
          </div>

          <CTAButton text="¡Quiero mi guía ahora! 🎉" href="#bonus" className="w-full md:w-auto" data-id="element-70" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 50
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative flex justify-center" data-id="element-71">
          <div className="absolute inset-0 bg-pastel-yellow rounded-full blur-3xl opacity-50 animate-pulse" data-id="element-72"></div>
          <img src="https://cdn.magicpatterns.com/uploads/1yNcwKtxNhGdgxQAzE6FtQ/heylloyd-image-1780873754835.png" alt="Portada del ebook Estimulación Temprana en Casa" className="relative z-10 w-full max-w-md rounded-3xl shadow-2xl transform rotate-3 hover:rotate-0 transition-transform duration-500 border-8 border-white" data-id="element-73" />
        </motion.div>
      </div>
    </section>;
}